export const displayName: {
  display_name: string;
} = {
  display_name: 'Picwell',
};
